import type { ReactNode } from "react";
import "./SiteScheduleAnalysis.scss";
import ScheduleToolbar from "../toolbar/ScheduleToolbar.tsx";
import PeriodSummaryCard from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/PeriodSummaryCard.tsx";
import LaborCostCard from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost/LaborCostCard.tsx";
import LaborCostDetailsCard from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost-details/LaborCostDetailsCard.tsx";

export default function SiteScheduleAnalysis(): ReactNode {
  return (
    <div className="site-schedule-analysis">
      <ScheduleToolbar viewType="analysis" />
      <div className="cards">
        <PeriodSummaryCard />
        <LaborCostCard />
        <LaborCostDetailsCard />
      </div>
    </div>
  );
}
